import routerOptions0 from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: true,
  scrollBehaviorType: "auto"
}
export const hashMode = true
export default {
...configRouterOptions,
...routerOptions0,
}